
export default {
  name: 'BaseLeadTypeProduct',
  props: {
    lead: {
      type: Object,
      default: null,
    },
    sendBtnText: {
      type: String,
      default: 'Отправить',
    },
    successText: {
      type: String,
      default: 'Форма успешно отправлена',
    },
    theme: {
      type: String,
      default: 'light',
    },
    getCity: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isSend: false,
      userName: this.accountName(),
      userEmail: this.$auth.user?.email ?? null,
      userPhone: this.$auth.user?.phone ?? null,
      userCity: this.$auth.user?.profile?.city ?? null,
      isUserNameValid: false,
      isEmailValid: false,
      isPhoneValid: false,
      isValidCity: false,
    }
  },

  computed: {
    isValid() {
      return this.isUserNameValid &&
        this.isEmailValid &&
        this.isPhoneValid &&
        this.getCity
        ? this.isValidCity
        : true
    },
  },
  methods: {
    accountName() {
      if (this.$auth.loggedIn) {
        if (this.$auth.user.type === 'COMPANY') {
          return this.$auth.user.company?.title
            ? this.$auth.user.company?.title
            : this.$auth.user.username
        } else {
          return this.$auth.user.profile?.firstName &&
            this.$auth.user.profile?.lastName
            ? `${this.$auth.user.profile.firstName} ${this.$auth.user.profile.lastName}`
            : this.$auth.user.username
        }
      }
      return null
    },
    async sendLead() {
      const lead = {
        ...this.lead.data,
        from: {
          username: this.$auth.user?.username ? this.$auth.user.username : null,
          id: this.$auth.user?._id ? this.$auth.user._id : null,
          type: this.$auth.user?.type,
          name: this.userName,
          email: this.userEmail,
          phone: this.userPhone,
          city: this.getCity ? this.userCity : null,
          roles: this.$auth.user?.roles ? this.$auth.user.roles : null,
        },
      }

      try {
        this.isSend = false
        await this.$axios.$post('/lead/send/product', lead)
        await this.$auth.fetchUser()
        this.isSend = true
        this.$emit('send')
      } catch (error) {
        this.isSend = false
        console.log(error)
      }
    },
  },
}
